CropImageService.$inject = ['ModalService'];

export function CropImageService(ModalService) {
  var service = {
    open: openModal,
  };

  return service;

  //////////

  function openModal(item, saveLogoCallBack, width, height) {
    var itemId = 'logo-image';
    // if (item.id){ // Edit
    //     itemId = item.id; // it throws error
    // }

    ModalService.showModal({
      templateUrl: './app/ajs/_shared/services/crop-image/crop-image.service.html',
      controller: CropImageCtrl,
      controllerAs: 'vm',
      inputs: {
        itemId: itemId,
        width: width,
        height: height,
        saveLogoCallBack: saveLogoCallBack,
      },
    }).then(function (modal) {
      var preventModalClose = {
        backdrop: 'static',
        keyboard: false,
      };

      modal.element.modal(preventModalClose);
    });

    CropImageCtrl.$inject = [
      '$element',
      'CONFIGURATIONS',
      'itemId',
      'width',
      'height',
      'saveLogoCallBack',
    ];
  }

  function CropImageCtrl($element, CONFIGURATIONS, itemId, width, height, saveLogoCallBack) {
    const vm = this;

    const config = CONFIGURATIONS;

    vm.itemId = itemId;

    let cropWidth = width ? width : config.ITEM_IMAGE_WIDTH;
    let cropHeight = height ? height : config.ITEM_IMAGE_HEIGHT;

    let cropper = null;
    let fileName = '';
    let options = {
      thumbBox: '',
      spinner: '',
      imgSrc: '',
    };

    var setData = function () {
      $('#btnCrop').prop('disabled', true);
      $('#btnCenterImage').prop('disabled', true);
      $('#btnZoomIn').prop('disabled', true);
      $('#btnZoomOut').prop('disabled', true);

      // Default crop options
      options = {
        thumbBox: '#' + itemId + '-crop-thumbBox',
        spinner: '.spinner',
        imgSrc: '',
      };

      cropper = $('#' + itemId + '-crop-imageBox').cropbox(options);

      // Dinamic height
      var cropboxDiv = $('#' + itemId + ' .crop-imageBox .crop-thumbBox');
      cropboxDiv.height(cropHeight);
      cropboxDiv.width(cropWidth);
      $('#' + itemId + ' .crop-imageBox').height(cropboxDiv.height() + 100);
      $('.crop-thumbBox').css('margin-top', '50px');

      // When change the file update the crop image
      $('#file-' + itemId).on('change', function () {
        // Check file Formats
        if (!config.IMAGE_PERMITTED_FORMAT[this.files[0].type]) {
          return false;
        }

        var reader = new FileReader();
        fileName = this.files[0].name;

        reader.onload = function (e) {
          // options.imgSrc = e.target.result as string;
          options.imgSrc = e.target.result;

          cropper = $('#' + itemId + '-crop-imageBox').cropbox(options);

          $('#btnCrop').prop('disabled', false);
          $('#btnCenterImage').prop('disabled', false);
          $('#btnZoomIn').prop('disabled', false);
          $('#btnZoomOut').prop('disabled', false);
        };

        reader.readAsDataURL(this.files[0]);
        ////this.files = []; check
      });
    };

    // After load the directive run jquery
    // Setting the image size croped
    setTimeout(function () {
      setData();
    }, 10);

    // Helper for actions on the view
    vm.uiCropImage = {
      setDefaultImage: function () {
        options.imgSrc = config.DEFAULT_IMAGE;
        cropper = $('#' + itemId + '-crop-imageBox').cropbox(options); // jQuery
      },
      zoomIn: function () {
        if (cropper) {
          cropper.zoomIn();
        }
      },
      zoomOut: function () {
        if (cropper) {
          cropper.zoomOut();
        }
      },
      cropImage: function () {
        if (fileName) {
          var cropedImage = {
            file: cropper.getBlob(),
            fileName: fileName,
          };

          vm.sendingForm = true;
          setTimeout(function () {
            // Delay x sec
            vm.sendingForm = false;

            $element.modal('hide');
            saveLogoCallBack(cropedImage);
            // close(cropedImage, 500);
          }, 500);
        }
      },
      centerImage: function () {
        cropper = $('#' + itemId + '-crop-imageBox').cropbox(options); // jQuery // TODO: willy - check
      },
      cancel: function () {
        $element.modal('hide');
        // close(null, 500);
      },
    };

    vm.closeModal = function () {
      $('.modal').remove();
    };
  }
}
